
<template>
 <div class="HomePage">
  <div class="break"></div>
 <MarqueeText></MarqueeText>
   <div class="break"></div>
 <div ref="hero" class="Hero">
   <div class="MainPageText">
     <div class="TitleContainer">
       <h1 class="Title">Residential & Commercial Roofing Contractor </h1>
       <h2 class="subTitle">Based in Niles, serving all of southwest Michigan</h2>
       <ul class="facts-list">
         <li>Locally Owned and Operated</li>
         <li>Licensed and insured for your protection</li>
         <li>Financing Options Available</li>
         <li>High-quality materials and workmanship</li>
         <li>Free estimates and competitive pricing</li>
         <li>Roofing repair services available</li>
         <li>Customer satisfaction guaranteed</li>
       </ul>
     </div>
     <div class="SubTitleContainer">
       <ContactForm :modal="this.modal"></ContactForm>  
     </div>
   </div>
   <div>
   <div v-if="showContactForm" class="floatingContact">
     <ContactForm :modal="this.modal"></ContactForm>
   </div>
 
 </div>
 </div>

   <!-- Main content wrapper with gradient background -->
   <div class="main-content-wrapper">
   <div class="break"></div>
   <div class="Services">
    <span class="ServicesTitle">Check out our Google Reviews!</span>
    <CustomerTestimonials/>
   </div>
   <div class="break"></div>
    <IdentityPage/>
   <div class="break"></div>
    <LicensedInsured/>
    <AwardsPage/>
  <div class="break"></div>
  <div class="Services">
   <span class="ServicesTitle">Services</span>
   <div class="serviceSelection">
     <PhotoCard v-for="(service, index) in services" :key="index"
     :Services="service" @click="goToPage(service.path)">
    </PhotoCard>
   </div>
   <div class="break"></div>
   <DonateCTA/>

 </div>
 <div class="break"></div>
 <div id="footer">
   <PageFooter/>
 </div>
 </div>
 <!-- End main content wrapper -->

 </div>
 </template>
 
 <script>
 import ContactForm from '@/components/ContactForm.vue';
 import PhotoCard from '@/components/NewServiceSelector.vue';
 import MarqueeText from '@/components/MarqueeText.vue';
 import PageFooter from '@/components/PageFooter.vue';
 import LicensedInsured from '@/components/LicensedInsured.vue';
 import IdentityPage from '@/components/IdentityPage.vue';
 import AwardsPage from '@/components/AwardsPage.vue';
 import CustomerTestimonials from '@/components/CustomerTestimonials.vue';
 import DonateCTA from '@/components/DonateCTA.vue';
 
 export default {
   name: 'HomePage',
   data(){
     return{
       modal: false,
       services: [

       {
         imageSrc: require('@/assets/RoofingRepairPhoto.jpg'),
         title: 'Roofing Replacement',
          path: '/roofing-projects',
       },

       {
         imageSrc: require('@/assets/FasciaSoffit/Roof1.jpg'),
         title: 'Fascia & Soffit',
         path: '/fascia-soffit',
       },

       {
         imageSrc: require('@/assets/Repairs/Repair1.jpg'),
         title: 'Roofing Repairs',
         path: '/repair-projects',
       },

     ],
     showContactForm: true,
     }
   },
 
   components: {
     ContactForm,
     PhotoCard,
     PageFooter,
     LicensedInsured,
    CustomerTestimonials,
    IdentityPage,
    AwardsPage,
    MarqueeText,
    DonateCTA
   },
   mounted() {
     // Add structured data for SEO
     const script = document.createElement('script');
     script.type = 'application/ld+json';
     script.text = JSON.stringify({
       "@context": "https://schema.org",
       "@type": "RoofingContractor",
       "name": "Homes Roofing Co LLC",
       "image": "https://homesroofing.com/img/HomesRoofingLogo.jpg",
       "description": "Professional roofing contractor in Southwest Michigan specializing in roof replacement, repairs, fascia, soffit, gutters, and siding. 50-year warranty available.",
       "address": {
         "@type": "PostalAddress",
         "addressLocality": "Southwest Michigan",
         "addressRegion": "MI",
         "addressCountry": "US"
       },
       "geo": {
         "@type": "GeoCoordinates",
         "latitude": "42.2917",
         "longitude": "-85.5872"
       },
       "telephone": "+1-269-262-5055",
       "email": "homesroofingllc@gmail.com",
       "url": "https://homesroofing.com",
       "priceRange": "$$$",
       "areaServed": {
         "@type": "State",
         "name": "Michigan"
       },
       "serviceType": [
         "Roof Replacement",
         "Roof Repair",
         "Fascia Installation",
         "Soffit Installation",
         "Gutter Installation",
         "Siding Installation"
       ],
       "aggregateRating": {
         "@type": "AggregateRating",
         "ratingValue": "5",
         "reviewCount": "50"
       },
       "hasCredential": [
         "Master Craftsman Certified",
         "Shingle Master Certified",
         "EPA Lead-Safe Certified"
       ]
     });
     document.head.appendChild(script);
     
     // Add scroll listener
     console.log("mounted");
     window.addEventListener('scroll', this.handleScroll.bind(this));
   },
   beforeUnmount() {
     window.removeEventListener('scroll', this.handleScroll.bind(this));
   },
   methods: {
   handleScroll() {
    if (this.$refs.scrollElement) {
    // const scrollPosition = this.$refs.scrollElement.offsetHeight;
    // const heroHeight = this.$refs.hero.offsetHeight;
    this.showContactForm = true
  }

   },
   goToPage(path) {
      this.$router.push(path);
    },
 },

 }
 </script>
 
 <style>
   .HomePage {
    margin-top: 93px;
  }
  
  /* Main content wrapper with gradient background */
  .main-content-wrapper {
    background: linear-gradient(135deg, #002655 0%, #1a3a5c 50%, #4a7ba7 100%);
    width: 100%;
  }
  
  @media (max-width: 880px) {
    .HomePage {
    margin-top: 168px;
  } 

 }

.Hero {
  @media (max-width: 880px) {
    background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('../assets/Cover Roof Mobile.jpg');
  }
  @media (min-width: 880px) {
    background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('../assets/Cover Roof.jpg');
  } 

 padding: 50px;

 background-size: cover; /* Cover the entire .Hero area */
 background-position: center; /* Center the image */
 background-repeat: no-repeat; /* Do not repeat the image */
}



/* Desktop Specific */
@media (min-width: 880px) {

 .MainPageText {
  height: 70vh;
  min-height: 500px;
  margin: 0px 15%;
  padding-top: 10%;
  display: flex;
  flex-direction: row;
}

 /* Adjust for shorter screens */
 @media (max-height: 800px) {
   .MainPageText {
     height: auto;
     min-height: unset;
     padding-top: 5%;
     padding-bottom: 30px;
   }
   
   .Hero {
     padding: 30px 50px;
   }
 }

 .TitleContainer{
  display: flex;
  flex-direction: column;
  width: 60%;
  align-items: flex-start;
 }
 @media screen and (max-width: 880px) {
   .TitleContainer{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
 }
}

.SubTitleContainer {
   align-content: center;
 }


.Title {
 font-size: 35px;
    letter-spacing: -1px;
    text-shadow: 2px 2px 0px #000000;
   color: #ffffff;
   font-family: 'Roboto Slab', sans-serif;
}

@media (max-height: 800px) and (min-width: 880px) {
  .Title {
    font-size: 28px;
    margin-bottom: 10px;
  }
  
  .subTitle {
    font-size: 1.2em !important;
    margin-bottom: 10px;
  }
}

.facts-list{
    color: #ffffff;
    display: flex;
    line-height: 1.5em;
    font-size: 18px;
    text-shadow: 2px 2px 0px #000000;
  letter-spacing: 2px;
    font-family: 'Roboto', sans-serif;
    flex-direction: column;
    align-items: flex-start;
    width: max-content;
}
.facts-list li {
  margin-bottom: 5px;
}

@media (max-height: 800px) and (min-width: 880px) {
  .facts-list {
    font-size: 15px;
    line-height: 1.3em;
    letter-spacing: 1px;
  }
  
  .facts-list li {
    margin-bottom: 3px;
  }
}
.facts-list li::marker {
  color: #ff0000; /* Change the bullet color to red */
}
@media (max-width: 880px) {
  .facts-list{
    color: #ffffff;
    display: flex;
    align-content: center;
    font-size: .7em;
    line-height: 1.6;
}
}
.facts-list 

.subTitle {
 font-family: 'Roboto', sans-serif; /* Use Open Sans font */
 font-size: 1.5em; /* Increase font size */
 font-weight: bold; /* Make text bold */
 letter-spacing: 1px; /* Add some letter spacing */
 text-shadow: 2px 2px 0px #000000;
 color: #ffffff; /* White text */
}
 
.ServicesTitle{
 color: #fff;
   text-shadow: 2px 2px 0px #000000;
   letter-spacing: 2px;
   font-size: 3em;
   position: relative;
   z-index: 2;
}

.Bold{
 font-weight: bold;
}

.Services{
  padding-top: 10px;
   display: flex;
   flex-direction: column;
   background: transparent;
}


.Services .Title {
 width: 100%;
 display: flex;
 justify-content: center;
 padding: 15px;
 font-size: -webkit-xxx-large;
}
.serviceSelection {
 display: flex;
 justify-content: space-around;
 flex-direction: row;
 flex-wrap: wrap;
}

.photo-card {
   display: flex;
   flex-direction: column;
   color: #bdbdbd;
   justify-content: center;
   align-items: center;
}


.HomeImage{
 height: 100%;
 width: 100%;
 border-radius: 10px;
 object-fit: cover;

 @media (max-width: 880px) {
   margin-bottom: 20px;

 }
}
.break{
 width: 100%;
 border-bottom: #8d0808 .25em solid;
}
.show-contact-form {
 position: fixed;
 bottom: 20px;
 right: 20px;
 display: block;
}
.floatingContact {

 .contact-button {

  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #950d0f; /* Change to your preferred color */
  color: white;
  border: none;
  border-radius: 50%;
  width: 90px;
  height: 70px;
  padding: 10px;
  text-align: center;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  animation: pulse 9s infinite;

   @media (min-width: 880px){
    width: 150px;
    right: 8%;
    top: 10px;
    z-index: 100;
   }
  }
  .financing-button {
    display : none;
}
}
.subTitle {
 font-family: 'Roboto', sans-serif; /* Use Open Sans font */
 font-size: 1.5em; /* Increase font size */
 font-weight: bold; /* Make text bold */
 letter-spacing: 1px; /* Add some letter spacing */
 text-shadow: 2px 2px 0px #000000;
 color: #ffffff; /* White text */
}

/* Make footer transparent to show gradient background */
.HomePage :deep(.footer) {
  background: transparent !important;
  background-image: none !important;
}

.HomePage ::v-deep .footer {
  background: transparent !important;
  background-image: none !important;
}

.main-content-wrapper .footer {
  background: transparent !important;
  background-image: none !important;
}

 
 </style>